import { render, staticRenderFns } from "./AuthorisePartOld.vue?vue&type=template&id=a37f0668"
import script from "./AuthorisePartOld.vue?vue&type=script&lang=js"
export * from "./AuthorisePartOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports